import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { Tabs } from "components";
import "modules/DealerOverviewDashboard/components/DealerOverviewHeader/DealerOverviewHeader.scss";

import type { TabData } from "components";

type DealerOverviewHeaderProps = {
  isUpdateDealerPending: boolean;
};

export const DealerOverviewHeader = ({ isUpdateDealerPending }: DealerOverviewHeaderProps) => {
  const { t } = useTranslation();

  const tabs: Map<string, TabData> = useMemo(
    () =>
      new Map([
        ["general", { data: [], id: "general", title: t("v8_general", "General"), icon: <Icon className="gears" /> }],
        ["dmsSystem", { data: [], id: "dmsSystem", title: t("v8_dms_system", "DMS / System"), icon: <Icon className="cloud" /> }],
        ["service", { data: [], id: "service", title: t("v8_service", "Service"), icon: <Icon className="wrench" /> }]
      ]),
    []
  );

  return (
    <div className="DealerOverviewHeader">
      <div className="row center">
        <div className="full tabs">
          <Tabs data={tabs} />
        </div>
        <div className="save">
          <Button color="green" type="submit" disabled={isUpdateDealerPending} loading={isUpdateDealerPending}>
            {t("v8_save", "Save")}
            <Icon className="check" />
          </Button>
        </div>
      </div>
    </div>
  );
};
